import './Services.scss';
import {
    ArrowUpRight,
    CodeXml,
    Palette,
    Smartphone,
} from 'lucide-react';
import {Link} from 'react-router-dom';
import {useTranslation} from "react-i18next";

type Service = {
    number: string;
    href: string;
    icon: 'video' | 'graphic' | 'development';
    accent: 'cyan' | 'violet' | 'redcoral';
};

const pageServices: Service[] = [
    {
        number: '01',
        href: '/servizi/video',
        icon: 'video',
        accent: 'redcoral',
    },
    {
        number: '02',
        href: '/servizi/grafica',
        icon: 'graphic',
        accent: 'violet',
    },
    {
        number: '03',
        href: '/servizi/development',
        icon: 'development',
        accent: 'cyan',
    },
];

function ServiceIcon({type}: { type: Service['icon'] }) {
    switch (type) {
        case 'video':
            return <Smartphone strokeWidth={1.6}/>;

        case 'graphic':
            return <Palette strokeWidth={1.6}/>;

        case 'development':
            return <CodeXml strokeWidth={1.6}/>;
    }
}

export default function Services() {
    const { t } = useTranslation();
    return (
        <section className="pageServices-section" id="servizi">
            <div className="pageServices-orb pageServices-orb--left"/>
            <div className="pageServices-orb pageServices-orb--right"/>

            <div className="pageServices-container">

                <header className="pageServices-header">

                    <h2>
                        {t("services.title.normal")}
                        <span> {t("services.title.bold")}</span>
                    </h2>

                    <p>
                        {t("services.subtitle")}
                    </p>

                    <div className="pageServices-header__eyebrow">
                        <span className="pageServices-header__line"/>
                        <span>{t("services.services")}</span>
                        <span className="pageServices-header__line"/>
                    </div>
                </header>



                <div className="pageServices-grid">
                    {pageServices.map((pageService) => (
                        <Link
                            key={pageService.number}
                            to={pageService.href}
                            className={`pageService-card pageService-card--${pageService.accent}`}
                            aria-label={`Scopri il servizio ${t(`services.card.${pageService.number}.title`)}`}
                        >
                            <div className="pageService-card__glow"/>

                            <div className="pageService-card__top">
                                <span className="pageService-card__category">
                                    {t(`services.card.${pageService.number}.title`)}
                                </span>
                            </div>

                            <div className="pageService-card__main">
                                <div className="pageService-card__icon">
                                    <div className="pageService-card__icon-glow"/>
                                    <ServiceIcon type={pageService.icon}/>
                                </div>

                                <div className="pageService-card__content">
                                    <h3 className="pageService-card__title">
                                        {t(`services.card.${pageService.number}.title`)}
                                    </h3>

                                    <p className="pageService-card__description">
                                        {t(`services.card.${pageService.number}.subtitle`)}
                                    </p>
                                </div>
                            </div>

                            <div className="pageService-card__bottom">
                                <span className="pageService-card__cta">
                                    {t("services.discoverservice")}
                                </span>

                                <span className="pageService-card__arrow">
                                    <ArrowUpRight strokeWidth={1.8}/>
                                </span>
                            </div>

                            <div className="pageService-card__shine"/>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}